<template>
    <div class="content" :class="visible ? 'content--visible' : ''">
        <h2>Tap-on or fuel up?</h2>
        <p>
            <strong>Taking another perspective on peak morning commute to the CBD...</strong>
        </p>
        <p>The city has been visualised to demonstrate how people living in certain areas could choose particular modes (including driving) to optimise the journey. This map visualises the primary mode that would be used on the fastest journey to the CBD.</p>
        <p>Despite road traffic being at its worst during peak hour, the vast majority of Melbourne postcodes still appear to be best suited to driving. This isn’t the case in parts of Melbourne’s Northeast and Inner South, where main driving corridors become relatively more congested.</p>
        <p>Major works such as the Metro Tunnel project (which is expected to decrease rail commute times on several lines) will continue to transform mode efficiency.</p>
        <p>Select a single postcode to follow through the journey.</p>
        <multiselect
            class="postcode__selector"
            :value="selectedPostcode"
            :options="data"
            track-by="postcode"
            label="label"
            @input="update_selected_postcode"
        ></multiselect>
    </div>
</template>

<script>
import tooltip_mixin from "@/assets/tooltip_mixin";

export default {
    props: {
        visible: {
            default: () => false
        }
    },
    mixins: [tooltip_mixin]
};
</script>

<style scoped>
.postcode__selector {
    width: 80%;
}
</style>
